import { forwardRef, useImperativeHandle } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import formatSeconds from './TimeFormat';

const ExportTaskExcelButton = forwardRef(({ translate, data, isAdmin }, ref) => {
  const download = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Sheet1');

    if (isAdmin) {
      const header = [
        translate('service_report.column_task.date'),
        `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.timeFormat')})`,
        `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.secFormat')})`,
        translate('service_report.column_task.customer'),
        translate('service_report.column_task.end_customer'),
        translate('service_report.column_task.address'),
        translate('service_report.column_task.city'),
        translate('service_report.column_task.service_site'),
        translate('service_report.column_task.service'),
        translate('service_report.column_task.feature'),
        translate('service_report.column_task.amount'),
        translate('service_report.column_task.user'),
        translate('service_report.column_task.additional_info'),
      ];
      sheet.addRow(header);

      let totalDuration = 0;
      let totalAmount = 0;

      data.forEach((item) => {
        totalDuration += item.totalDuration || 0;
        totalAmount += Number(item.invoicePrice || 0);

        sheet.addRow([
          item.localizedEndDate,
          formatSeconds(item.totalDuration || 0),
          item.totalDuration || 0,
          item.customer?.name || '',
          item.companyName || '',
          item.streetAddress || '',
          item.city || '',
          item.serviceSiteNo || '',
          item.localizedServiceName || '',
          item.additionalFeatures?.join(', ') || '',
          item.invoicePrice || '',
          item.userId || '',
          item.parsedInfo || '',
        ]);
      });

      sheet.addRow([]);
      sheet.addRow([
        `${translate('service_report.column_task.date')} (Total)`,
        formatSeconds(totalDuration),
        totalDuration,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        totalAmount.toFixed(2),
        '',
        '',
      ]);
    } else {
      const header = [
        translate('service_report.column_task.date'),
        `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.timeFormat')})`,
        `${translate('service_report.column_task.duration')} (${translate('service_report.column_task.secFormat')})`,
        translate('service_report.column_task.customer'),
        translate('service_report.column_task.terminal'),
        translate('service_report.column_task.address'),
        translate('service_report.column_task.city'),
        translate('service_report.column_task.service_site'),
        translate('service_report.column_task.service'),
        translate('service_report.column_task.amount'),
      ];
      sheet.addRow(header);

      let totalDuration = 0;

      data.forEach((item) => {
        totalDuration += item.totalDuration || 0;
        sheet.addRow([
          item.localizedEndDate,
          formatSeconds(item.totalDuration || 0),
          item.totalDuration || 0,
          item.customer?.name || '',
          item.companyName || '',
          item.streetAddress || '',
          item.city || '',
          item.serviceSiteNo || '',
          item.localizedServiceName || '',
          item.invoicePrice || '',
        ]);
      });

      sheet.addRow([]);
      sheet.addRow([
        `${translate('service_report.column_task.date')} (Total)`,
        formatSeconds(totalDuration),
        totalDuration,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ]);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${translate('service_report.search.type_task')}.xlsx`);
  };

  useImperativeHandle(ref, () => ({
    download,
  }));

  return null;
});

export default ExportTaskExcelButton;
